import { useTranslation } from "react-i18next";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import RegistrationForm from "./components/RegistrationForm";

const BENEFIT_ICONS = [
  "ri-database-2-line",
  "ri-file-edit-line",
  "ri-team-line",
  "ri-graduation-cap-line",
];
const BENEFIT_KEYS = [0, 1, 2, 3] as const;

export default function RegisterNgoPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen font-sans">
      <Navbar />

      {/* Page Hero */}
      <section className="bg-navy pt-32 pb-20 md:pt-36 md:pb-24">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-widest text-gold font-medium mb-4">
            {t("register.hero.label")}
          </p>
          <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight max-w-2xl mb-5">
            {t("register.hero.title")}
          </h1>
          <p className="text-white/60 text-base leading-relaxed max-w-xl">
            {t("register.hero.p")}
          </p>
        </div>
      </section>

      {/* Main content */}
      <section className="bg-white py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">

            {/* Left — benefits */}
            <div className="lg:col-span-2">
              <p className="text-xs uppercase tracking-widest text-gold font-medium mb-6">
                {t("register.why.label")}
              </p>
              <h2 className="text-2xl font-bold text-navy mb-8 leading-snug">
                {t("register.why.title")}
              </h2>
              <ul className="space-y-8">
                {BENEFIT_KEYS.map((i) => (
                  <li key={i} className="flex gap-4">
                    <span className="w-9 h-9 flex items-center justify-center flex-shrink-0 mt-0.5 bg-gold/10 rounded-md">
                      <i className={`${BENEFIT_ICONS[i]} text-gold text-lg`} />
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-navy mb-1">
                        {t(`register.benefit.${i}.title`)}
                      </p>
                      <p className="text-sm text-navy/55 leading-relaxed">
                        {t(`register.benefit.${i}.desc`)}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>

              <div className="mt-12 pt-8 border-t border-cool-gray-200">
                <p className="text-xs text-navy/40 leading-relaxed">
                  {t("register.privacy")}
                </p>
              </div>
            </div>

            {/* Divider */}
            <div className="hidden lg:block lg:col-span-0">
              <div className="w-px h-full bg-cool-gray-200 mx-auto" />
            </div>

            {/* Right — form */}
            <div className="lg:col-span-3">
              <p className="text-xs uppercase tracking-widest text-gold font-medium mb-6">
                {t("register.form.label")}
              </p>
              <RegistrationForm />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
